/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import type React from 'react';

export type StepComponent = React.FC;

export const stepRegistry: Record<string, StepComponent> = {};

export function registerStepComponent(type: string, component: StepComponent): void {
  stepRegistry[type] = component;
}

// Reset the shared registry. The registry is a mutable module singleton, so
// tests that touch it must call this in setup/teardown to avoid cross-file
// leakage — using Object.keys() (not `for...in`) skips inherited keys.
// The `__` prefix and `ForTests` suffix mark this as a test-only helper; do
// not call it from production code.
export function __resetStepRegistryForTests(): void {
  for (const key of Object.keys(stepRegistry)) {
    delete stepRegistry[key];
  }
}
